import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-bar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Step, {
      state: _ctx.isActive(0),
      number: 1,
      title: _ctx.$t('outils.compteur.bar.partenaire'),
      subtitle: _ctx.site?.description ?? ''
    }, null, 8, ["state", "title", "subtitle"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createVNode(_component_Step, {
      state: _ctx.isActive(1),
      number: 2,
      title: _ctx.$t('outils.compteur.bar.representant'),
      subtitle: _ctx.type?.libelle ?? ''
    }, null, 8, ["state", "title", "subtitle"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createVNode(_component_Step, {
      state: _ctx.isActive(2),
      number: 3,
      title: _ctx.$t('outils.compteur.bar.compteurs'),
      subtitle: _ctx.equipement
    }, null, 8, ["state", "title", "subtitle"])
  ]))
}